// extracted by mini-css-extract-plugin
module.exports = {"strick":"ContactUsComp_strick__afMp5"};